import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
var _excluded = ["offset"];
var _effectorFileName = "/builds/gmini/front-common/src/Services/UserClassifierRepoService/Node/UserClassifierRepoNode.ts";
import "core-js/modules/es.array.concat.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line import/no-cycle
export var UserClassifierRepoNode;

(function (_UserClassifierRepoNode) {
  var TYPE = _UserClassifierRepoNode.TYPE = 'UserClassifierRepoNode';

  var create = _UserClassifierRepoNode.create = function (_ref) {
    var _ref$offset = _ref.offset,
        offset = _ref$offset === void 0 ? 0 : _ref$offset,
        data = _objectWithoutProperties(_ref, _excluded);

    return _objectSpread(_objectSpread({}, data), {}, {
      offset: offset,
      type: TYPE,
      key: getKey(data)
    });
  };

  var is = _UserClassifierRepoNode.is = function (node) {
    return node.type === 'UserClassifierRepoNode';
  };

  var getKey = _UserClassifierRepoNode.getKey = function (_ref2) {
    var id = _ref2.id;
    return "".concat(TYPE, ":").concat(id);
  };

  var getByKey = _UserClassifierRepoNode.getByKey = function (nodes, key) {
    var node = nodes[key];
    return node && is(node) ? node : null;
  };
})(UserClassifierRepoNode || (UserClassifierRepoNode = {}));